import { GridToolbarColumnsButton, GridToolbarContainer } from '@mui/x-data-grid';

const CompanyContactsToolbar = () => (
	<GridToolbarContainer sx={{ px: 1 }}>
		<GridToolbarColumnsButton />
	</GridToolbarContainer>
);

export default CompanyContactsToolbar;
